export default __webpack_public_path__ + "static/media/twitter-x-logo.8c17a523.svg";